import React from 'react';
import { BIG_HORIZONTAL_MARGIN_FN, SMALL_MARGIN_VERTICAL_FN } from '../../config/designSystem/Layout';
import { Body1Reg, Caption1Bold } from '../../config/designSystem/typography';
import { COLORS } from '../../config/designSystem/Colors';
import { FontAwesome } from '@expo/vector-icons';
import { SPACING } from '../../config/designSystem/Spacing';
import { TouchableOpacity, View } from 'react-native';
import { logAmplitude } from '../../utils/analytics/analytics';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

interface FAQProps {
    title: string,
    text: string,
    extraInfo : {
      [key: string]: string
    }
    backgroundColor?: string,
    backgroundColorText?: string,
    opacity? : number,
    textColor?:string,
    titleTextColor?:string
  }

export const FAQ = ({ title, text, extraInfo, backgroundColor, backgroundColorText, opacity,textColor,titleTextColor }: FAQProps) => {

  const {height, width} = useAvailableDimensions();

  const [isCollapsed,setIsCollapsed] = React.useState<boolean>(true);

  return(
    <View style={{
      borderRadius: SPACING['sp-8'],
      borderStyle: 'solid',
      borderWidth: 2,
      borderColor: COLORS.border.primary,
      backgroundColor: COLORS.surface.contrast,
      width: '90%',
      marginHorizontal: BIG_HORIZONTAL_MARGIN_FN(width),
      marginVertical: SMALL_MARGIN_VERTICAL_FN(height),
    }}>
      <TouchableOpacity
        onPress={() => {
          logAmplitude('FAQ Opened',extraInfo);
          setIsCollapsed(!isCollapsed);
        }} >
        <View
          style={{

            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',

            paddingHorizontal: 15,
            paddingVertical: 10,
          }}
        >
          <Caption1Bold color={COLORS.content.primary}>
            {title}
          </Caption1Bold>
          <FontAwesome name={isCollapsed ? 'chevron-down' : 'chevron-up'} color={COLORS.content.primary}/>
        </View>
      </TouchableOpacity>
      {!isCollapsed &&
          (
            <View style={[{
              paddingHorizontal: 15,
              paddingVertical: 10}, !!backgroundColorText && {backgroundColor:backgroundColorText}]}>
              <Body1Reg color={COLORS.content.secondary}>
                {text}
              </Body1Reg>


            </View>)
      }
    </View>);
};